import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { CaretUpDown, Check, Buildings } from "@phosphor-icons/react";

// Searchable client picker. `value` is the client name or "all".
export function ClientCombobox({ value, onChange, clients = [], allLabel = "All clients", className = "", testid = "client-combobox" }) {
  const [open, setOpen] = useState(false);
  const label = value && value !== "all" ? value : allLabel;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} data-testid={testid}
          className={`justify-between rounded-sm h-9 text-xs font-normal px-3 ${className}`}>
          <span className="flex items-center gap-1.5 truncate"><Buildings size={13} className="text-muted-foreground shrink-0" /><span className="truncate">{label}</span></span>
          <CaretUpDown size={13} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-56 rounded-sm" align="start">
        <Command className="rounded-sm">
          <CommandInput data-testid={`${testid}-search`} placeholder="Search client…" className="h-9 text-xs" />
          <CommandList className="max-h-64">
            <CommandEmpty className="py-4 text-center text-xs text-muted-foreground">No client matches.</CommandEmpty>
            <CommandGroup>
              <CommandItem value="__all__" onSelect={() => { onChange("all"); setOpen(false); }} data-testid={`${testid}-opt-all`} className="text-xs">
                <Check size={13} className={`mr-2 ${value === "all" || !value ? "opacity-100" : "opacity-0"}`} /> {allLabel}
              </CommandItem>
              {clients.map(c => (
                <CommandItem key={c.id || c.name} value={c.name} onSelect={() => { onChange(c.name); setOpen(false); }}
                  data-testid={`${testid}-opt-${(c.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-xs">
                  <Check size={13} className={`mr-2 ${value === c.name ? "opacity-100" : "opacity-0"}`} /> {c.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
